import { createReduxStore } from "./redux_store";

// All the organizations the person associated with the user is in.
// On the backend, a person can have many users, users only have one org.
const UserOrgsStore = createReduxStore({ name: "userOrgs" });

export { UserOrgsStore };
